<template>

  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-flex Flex gv-0 av-bottom">

        <div class="etx-flex__item Flex__item c-2 tab-l:c-1 tab-l:o-1" v-if="graphic?.url?.path">
          <div class="etx-media Media slogan-overlap will-appear move-up">
            <picture>
              <MediaIcon :media="graphic" />
            </picture>
          </div>
          <div class="etx-spacer Spacer h-50 tab-l:h-125"></div>
        </div>

        <div class="etx-flex__item Flex__item c-10 tab-l:c-5 desk-s:c-6 tab-l:o-2">

          <div class="FixedRatio ratio-4-5 falling-off-right desk-l:falling-off-max-right slogan-overlap" :class="entranceClassList">

            <div class="etx-background-media BackgroundMedia" :class="backgroundMediaClassList">
              <div class="etx-media Media" v-if="image">
                <MediaImage :media="image" imageStyle="image_4_5" />
              </div>
            </div>

          </div>

          <div class="etx-spacer Spacer h-0 tab-l:h-75"></div>

        </div>

        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-6 desk-s:c-5">

          <div class="etx-card Card bg-secondary">

            <div class="Card__background fullwidth"></div>

            <div class="etx-card__item Card__item ph-0 tab-l:pr-150 pv-0">

              <div class="etx-spacer Spacer h-125 tab-l:h-75"></div>

              <div class="etx-text Text" :class="entranceClassList" v-if="heading || lead || text">
                <h2 v-if="heading && headingType == 'h2'" class="font-h2 font-color-primary">{{
                  heading }}</h2>
                <h4 v-else-if="heading && headingType == 'h4'" class="font-h2 font-color-primary">{{
                  heading }}</h4>
                <h3 v-else-if="heading" class="font-h2 font-color-primary">{{
                  heading }}</h3>

                <p v-if="headingSubline" class="font-h2 alt">{{ headingSubline }}</p>

                <p class="font-size-large font-weight-bold font-color-primary" v-if="lead"
                  v-html="lead.replace(/\n/g, '<br>')"></p>
                <HelperHtmlRenderer :htmlContent="text" />
              </div>

              <BlokkliProxyMode :isEditing="isEditing" fieldName="field_link_elements_rev" :elements="buttons" />
              <div class="etx-button-list ButtonList" :class="entranceClassList" v-if="buttons?.length > 0">
                <Button v-for="button in buttons" :type="button?.type" :targetBlank="button?.targetBlank"
                  :href="button?.link?.domainUri?.path || button?.link?.uri?.path" :label="button?.label" :alt="button?.alt" />
              </div>

              <div class="etx-spacer Spacer h-75"></div>

            </div>

          </div>


        </div>

      </div>

    </div>
  </div>

</template>

<script lang="ts" setup>

const props = defineProps<{
  heading?: string
  headingType: string
  headingSubline?: string
  lead?: string
  text?: string
  buttons: Array<any>
  image?: {
    url: {
      path: string
    }
    alt: {
      alt: string
    }
    title: string
  }
  graphic?: {
    url: {
      path: string
    }
    alt: {
      alt: string
    }
    title: string
  }
  verticalAlign?: string
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'text_image_2_col_special',
  globalOptions: ['spacingTop', 'spacingBottom'],
})


const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

const backgroundMediaClassList = computed(() => {

  if (props?.verticalAlign && props?.verticalAlign != 'center') {
    return props?.verticalAlign
  }

  if (props?.image?.verticalAlign && props?.image?.verticalAlign != 'center') {
    return props?.image?.verticalAlign
  }

  return ''
})

</script>
